import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { API_BASE_URL, X_API_KEY } from '../../services/api'
import CookieManager from '../lib/CookiesManager'
import ImageWithApiKey from './ImageWithApiKey'

interface Image {
  fileName: string
  status: number | null
}

interface GalleryProps {
  images: Image[]
  maxImages?: number
  statusToShow?: number[]
}

const GalleryRow: React.FC<GalleryProps> = ({
  images,
  maxImages = 7,
  statusToShow = [],
}) => {
  const { t } = useTranslation()
  const [filteredImages, setFilteredImages] = useState<Image[]>([])
  const userId = CookieManager.getUserId()

  const shouldDisplayImage = (
    imageStatus: number | null,
    currentStatus: number[],
  ): boolean => {
    if (imageStatus === null) {
      return false
    }

    return (
      currentStatus.length === 0 ||
      currentStatus.some(status =>
        imageStatus.toString().includes(status.toString()),
      )
    )
  }

  useEffect(() => {
    const filteredByStatus = images.filter(img =>
      shouldDisplayImage(img.status, statusToShow),
    )
    setFilteredImages(filteredByStatus.slice(0, maxImages))
  }, [images, maxImages, statusToShow])

  return (
    <div className='mt-4 sm:mt-5 bg-grisclair rounded-lg'>
      <div className='bg-grisclair2 m-2 p-2 sm:p-3 font-bold rounded-lg text-center'>
        {t('create-ad.my-gallery')}
      </div>

      <div className='relative'>
        <div className='flex overflow-x-auto pb-2 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent'>
          <div className='flex gap-2 sm:gap-3 px-2 sm:px-3 min-w-full'>
            {filteredImages.length > 0 ? (
              filteredImages.map((image, index) => (
                <div
                  key={index}
                  className='flex-shrink-0 rounded-lg overflow-hidden'
                >
                  <ImageWithApiKey
                    imageUrl={`${API_BASE_URL}/images/${userId}/${image.fileName}`}
                    apiKey={X_API_KEY}
                    maxWidth='150px'
                  />
                </div>
              ))
            ) : (
              <div className='w-full py-8 sm:py-12'>
                <p className='text-center text-gray-500 text-sm sm:text-base'>
                  {t('no-images-found')}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GalleryRow
